/*
 * ProjectUtilisationSettingsForm.tsx
 * Author: fwunderlich
 * Date: 31.01.2024
 *
 * Copyright: DMT GmbH & Co. KG
 */


import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import {showMessageOnError, showMessageOnSuccess} from '../global/CustomToast';
import {Project, updateUtilisationSettings,} from '../functions/Project';
import Input from '../global/Input';
import {classNames} from 'primereact/utils';
import ProjectTypeSelectlist from './ProjectTypeSelectList';
import {
    injectedUtilisationApi,
    useGetUtilisationTranslateQuery,
    useSetUtilisationTranslateMutation
} from '../../redux/rtk/injectedUtilisationApi';

type Props = {
    project: Project,
}

/**
 * Form for editing and creating of projects
 * @param props
 * @constructor
 */
const ProjectUtilisationSettingsForm = (props: Props): JSX.Element => {

    const {t} = useTranslation(['common']);

    const [utilData, setUtilData] = useState<any>(undefined);

    const defaultValues = {};

    const {
        control,
        formState: {errors},
        handleSubmit,
        reset,
        getValues,
        setValue,
        watch
    }: any = useForm();

    const utilisation = useGetUtilisationTranslateQuery({
        projectId: props.project?.id
    });

    const [saveUtil, saveUtilResult] = useSetUtilisationTranslateMutation();

    useEffect(() => {
        if (utilisation.data) {
            setUtilData(utilisation.data);
        }
    }, [utilisation.data]);

    useEffect(() => {
        if (utilData) {
            let defaultValues: any = {};

            for (let i = 0; i < utilData.length; i++) {
                let d = utilData[i];
                for (let j = 0; j < d.rows.length; j++) {
                    let row = d.rows[j];
                    defaultValues[row.id.toString()] = row.value;
                }
            }

            console.log(defaultValues);
            reset(defaultValues);
        }
    }, [utilData]);

    const saveData = (data: any) => {
        console.log('saveData: ', data);

        saveUtil({project_id: props.project.id, ids: data}).then((result: any) => {
            if (result.error) {
                showMessageOnError(t('error'), result.error);
            } else {
                showMessageOnSuccess(t('success'), t('projectManagement:toasts.projectUpdated'));
            }
        });

    };

    return (<div className={'card mb-0'}>
        <form id="projectForm" onSubmit={handleSubmit(saveData)} style={{height: '100%'}}>
            <h3>{t('projectMasterData:utilisation.ownNames')}</h3>
            {utilData && <div className={'grid mt-3'}>
                <div className={'grid w-full'}>
                    {/*<div className={'col-3 flex flex-column'}>*/}
                    {/*    <div className={'py-1 px-2'}></div>*/}
                    {/*    {utilData[0].rows.map((row: any, rowIndex: number) => {*/}
                    {/*        return <div className={'py-3 px-2'}>{t('projectMasterData:utilisation.' + row.label)}</div>*/}
                    {/*    })}*/}
                    {/*</div>*/}
                    {utilData.map((col: any) => {
                        return <div className={'col-12 lg:col-4 flex flex-column'}>
                            {col.rows.map((row: any, rowIndex: number) => {
                                return <div className={'px-2'}><Input edit={true} className={'mt-2'}
                                                                      name={row.id.toString()}
                                                                      placeholder={t('projectMasterData:utilisation.' + row.label)}
                                                                      label={rowIndex === 0 ? t('projectMasterData:utilisation.' + col.label.replaceAll(' ', '')) : ''}
                                    // value={getValues(row.id.toString())}
                                    // onChange={(e: any) => {
                                    //     setValue(row.id.toString(), e.target.value)
                                    // }}
                                                                      validationControl={control}
                                                                      validationRules={{required: false}}/></div>;
                            })}</div>;
                    })}
                </div>
            </div>}
        </form>
    </div>);
};

export default ProjectUtilisationSettingsForm;
